import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { List, ListItem } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Spin, Tooltip, Typography } from "antd";
import "./servicelist.css";
import { SearchOutlined } from "@mui/icons-material";

function ServiceList({ data, onToggle, toggled, isLoading }) {
	const [serviceList, setServiceList] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");

	useEffect(() => {
		setServiceList(data);
	}, [data]);

	const handleSearchChange = (event) => {
		setSearchQuery(event.target.value);
	};

	const filteredServices = serviceList?.filter((service) => service.title.toLowerCase().includes(searchQuery.toLowerCase()));

	const sortData = (dataList) => dataList?.sort((optionA, optionB) =>
		(optionA?.title || "").toLowerCase().localeCompare((optionB?.title || "").toLowerCase())
	);
    const sortedServices = sortData(filteredServices);

	return (
		<div>
			<div>
				<TextField className="serviceslist-search-input" label="Search" variant="outlined" value={searchQuery} onChange={handleSearchChange}
					InputProps={{
						endAdornment: <SearchOutlined className="searchIcon" />,
					}}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            color: "#000",
                            "&.Mui-focused": {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "var(--main-theme-color) !important",
                                borderWidth:"1px !important" 
                              },
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            "&.Mui-focused": {
                              color: "var(--main-theme-color) !important",
                              borderWidth:"1px !important"
                            },
                          },
                    }}
				/>

			</div>
			<List className="serviceslist">
				{isLoading ? (
					<Spin className="d-flex justify-content-center m-auto" />
				) : (sortedServices?.map((service) => (
					<ListItem key={service.title} className="serviceslist-listitem">
						<Typography className="serviceslist-listitem-font">{service.title}</Typography>
						<button className="toggleButton" onClick={() => onToggle(service, toggled[service.title])}>
							{toggled[service.title] ? <Tooltip title="Remove" placement="right"><RemoveIcon className="serviceslist-remove-icon" /></Tooltip> : <Tooltip title="Add" placement="right"><AddIcon className="serviceslist-add-icon" /></Tooltip>}
						</button>
					</ListItem>
				))
				)}
			</List>
		</div>
	);
}

export default ServiceList;
